import React from "react";
import { urgencyOf } from "@/lib/dateUtils";
import { useI18n } from "@/context/I18nContext";
import { DASHBOARD } from "@/constants/testIds";

// Visual countdown badge used in order rows
export default function CountdownBadge({ deliveryDate, orderId, size = "md" }) {
  const { t } = useI18n();
  const { bucket, days } = urgencyOf(deliveryDate);

  const styles = {
    overdue: { bg: "#D92D20", fg: "#ffffff", label: t("overdue_by", days) },
    today: { bg: "#D92D20", fg: "#ffffff", label: t("due_today") },
    tomorrow: { bg: "#FF8A00", fg: "#ffffff", label: t("due_tomorrow") },
    two_days: { bg: "#FFCC00", fg: "#0E0E10", label: t("days_remaining", days) },
    future: { bg: "#E7E3DA", fg: "#0E0E10", label: t("days_remaining", days) },
    none: { bg: "#E7E3DA", fg: "#0E0E10", label: "—" },
  };

  const s = styles[bucket];
  const sizeClass = size === "lg"
    ? "px-4 py-3 text-base"
    : size === "sm"
    ? "px-2 py-1 text-xs"
    : "px-3 py-2 text-sm";

  return (
    <div
      data-testid={DASHBOARD.countdownBadge(orderId)}
      className={`inline-flex items-center gap-2 font-mono-tech font-bold tracking-tight ${sizeClass}`}
      style={{ background: s.bg, color: s.fg }}
    >
      {(bucket === "overdue" || bucket === "today") && (
        <span className="w-2 h-2 bg-white animate-pulse" aria-hidden="true" />
      )}
      <span>{s.label}</span>
    </div>
  );
}
